import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from "rxjs/operators";
import { ConfigService } from '../../../config/config.service';
import { ClientService } from '../../shared/client/client.service';
import { Motifs } from './motifs';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(
    private configService: ConfigService,
    private http: HttpClient,
    private clientService: ClientService
  ) { }

  getMotifs(): Observable<Motifs[]> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.get<Motifs[]>(config.apiPoint + config.getMotifs);
      })
    );
  }

  sendReclamation(client, query): Observable<any> {
    return this.configService.getConfig().pipe(
      mergeMap(config => {
        return this.http.post<Observable<any>>(config.apiPoint + config.getClientReclamationSend.replace('{client}', client.id), query);
      }));
  }
}
